module.exports = __webpack_public_path__ + "img/b.fb12fddd.jpg";